module.exports = __webpack_public_path__ + "img/logo.9be6bc8a.png";